/* eslint react/prop-types: 0 */
import React from "react";
import { Link } from "gatsby";

import * as theme2Styles from "../scss/theme2.module.scss";
import { getTranslatedValue } from "../../../helpers/translationHelper";
import {
  calculateBedroomsRange,
  calculateBathroomsRange,
} from "../../../helpers/buildingHelper";
import { prepareImageURL } from "../../../helpers/helper";

import property1 from "../images/property-image-1.jpg";
import bed from "../images/bed.svg";
import bathtub from "../images/bathtub.svg";
import swimming from "../images/swimming-pool.svg";

const BuildingList = ({ buildings, locale, defaultLocale }) => {
  return (
    <div className={`${theme2Styles.productRow}`}>
      {buildings.map((building) => {
        const { pictures, property_type, layouts, translations } = building;
        const bedroomsRange = calculateBedroomsRange(layouts);
        const bathroomsRange = calculateBathroomsRange(layouts);

        const picture =
          pictures.length > 0
            ? prepareImageURL(pictures[0], 480, 320, false)
            : property1;

        return (
          <div className={theme2Styles.colm} key={building.uuid}>
            <div className={`${theme2Styles.productBox}`}>
              <Link
                to={`/${locale}/building/${building.uuid}`}
                className={theme2Styles.image}
              >
                <img alt="image" src={picture} />
                {(() => {
                  if (property_type && property_type.translations.length > 0) {
                    const propertyType = getTranslatedValue(
                      property_type.translations,
                      "name",
                      locale,
                      defaultLocale
                    );
                    if (propertyType) {
                      return (
                        <span className={theme2Styles.type}>
                          {propertyType}
                        </span>
                      );
                    }
                  }
                })()}
              </Link>
              <div className={theme2Styles.details}>
                <div className={theme2Styles.top}>
                  <h3>
                    <Link to={`/${locale}/building/${building.uuid}`}>
                      {building.name}
                    </Link>
                  </h3>
                  <h4
                    dangerouslySetInnerHTML={{
                      __html:
                        getTranslatedValue(
                          translations,
                          "headline",
                          locale,
                          defaultLocale
                        ) || "",
                    }}
                  ></h4>
                  <p>{building.location}</p>
                </div>
                <div className={theme2Styles.bottom}>
                  <div className={theme2Styles.features}>
                    {bedroomsRange != 0 && <div className={theme2Styles.li}>
                      <img alt="image" src={bed} />
                      <span>{bedroomsRange}</span>
                    </div>}
                    {bathroomsRange != 0 && <div className={theme2Styles.li}>
                      <img alt="image" src={bathtub} />
                      <span>{bathroomsRange}</span>
                    </div>}
                    <div className={theme2Styles.li}>
                      <img alt="image" src={swimming} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BuildingList;
